// extracted by mini-css-extract-plugin
export var header = "_ig-0";